<script setup>
import { DsButton, DsText } from '@coloplast/design-system';

const props = defineProps({
	labels: Object,
	products: Array,
	hideComplimentaryProductQuantity: Boolean
});

</script>
<template>
	<div class="c-delivery-cart__frame container" v-if="products.length > 0">
		<section class="c-delivery-cart__header">
			<div>
				<DsText htmlElement="h2" text-type="heading-2xl" text-style="bold">
					{{ props.labels.complimentaryProductsCardHeading }}
				</DsText>
			</div>
			<div>
				<DsButton variant="link" :href="labels.complimentaryProductsEditLink">
					{{ props.labels.editBasketLabel }}
				</DsButton>
			</div>
		</section>
		<ul>
			<li v-for="item in products" :key="item.imageUrl">
				<figure>
					<img
						class="c-global-basket__product-image"
						:src="item.imageUrl"
						:alt="item.name"
						v-if="item.imageUrl"
					/>
				</figure>
				<DsText v-if="!hideComplimentaryProductQuantity" html-element="span" text-type="body-md">
					{{ props.labels.quantityLabel }}: {{ item.quantity }}
				</DsText>
			</li>
		</ul>
	</div>
</template>
<style lang="scss" scoped>
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';
.container {
	margin-top: 24px;
	padding-bottom: 20px;
}

ul {
	list-style: none;
	margin: 0;
	padding: 0;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(82px, 82px));
	grid-gap: 18px;
}

figure {
	width: 82px;
	height: 82px;
	margin: 0;
	padding: 0;
	background-color: ds-color('bg', 'neutral-subtle');
	border-radius: 8px;
}
</style>
